export default __webpack_public_path__ + "android.ee3a481b.png";